import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface Release {
  version: string;
  date: string;
  description: string;
  type: 'feat' | 'fix' | 'ui' | 'chore';
}

const releases: Release[] = [
  { version: '1.0.168', date: '15-09-2026', type: 'chore', description: 'Use Quay registry for MinIO' },
  { version: '1.0.166', date: '15-09-2026', type: 'chore', description: 'Trigger frontend deployment' },
  { version: '1.0.165', date: '15-09-2026', type: 'chore', description: 'Add homepage create actions' },
  { version: '1.0.164', date: '11-09-2026', type: 'chore', description: 'Show recent events in archive and simplify navigation' },
  { version: '1.0.163', date: '10-09-2026', type: 'feat', description: 'vis alle kommende arrangementer paa forsiden sorteret efter dato' },
  { version: '1.0.162', date: '09-09-2026', type: 'fix', description: 'undgaa dobbelt login ved netvaerksfejl og isoler notifikationsfejl ved kommentarer' },
  { version: '1.0.161', date: '03-08-2026', type: 'chore', description: 'minor whitespace fix i README' },
  { version: '1.0.160', date: '03-08-2026', type: 'chore', description: 'Update deploy.yml' },
  { version: '1.0.167', date: '03-08-2026', type: 'chore', description: 'Create deploy.old' },
  { version: '1.0.159', date: '30-07-2026', type: 'fix', description: 'push notifications med email fallback for inaktive brugere' },
  { version: '1.0.158', date: '24-07-2026', type: 'chore', description: 'Stabilize Portainer redeploy with GHCR image-based stack' },
  { version: '1.0.157', date: '24-07-2026', type: 'chore', description: 'Improve Portainer stack startup compatibility' },
  { version: '1.0.156', date: '24-07-2026', type: 'chore', description: 'Fix Prisma pool exhaustion with shared singleton client' },
  { version: '1.0.155', date: '04-06-2026', type: 'fix', description: 'improve event RSVP reminder reliability and email audit accuracy' },
  { version: '1.0.154', date: '01-06-2026', type: 'chore', description: 'Fix build: tilføj archived til FeedQuery interface' },
  { version: '1.0.153', date: '01-06-2026', type: 'chore', description: 'Forlæng JWT-udløb fra 7 dage til 365 dage (husk login)' },
  { version: '1.0.152', date: '12-05-2026', type: 'feat', description: 'deep-link push notifications to specific posts' },
  { version: '1.0.151', date: '12-05-2026', type: 'fix', description: 'resolve recipientName from userId in audit log list' },
  { version: '1.0.150', date: '12-05-2026', type: 'fix', description: 'show specific notification details in audit log' },
  { version: '1.0.149', date: '12-05-2026', type: 'feat', description: 'add admin Notificer alle button on posts' },
  { version: '1.0.148', date: '12-05-2026', type: 'feat', description: 'log all notification dispatches to audit log' },
  { version: '1.0.147', date: '12-05-2026', type: 'chore', description: 'Flyt Dagens Tip fra forsiden til profilsiden' },
  { version: '1.0.146', date: '07-05-2026', type: 'feat', description: 'notify event attendees when a comment is posted on an event post (opt-out)' },
  { version: '1.0.145', date: '06-05-2026', type: 'ui', description: 'reduce padding/margin on admin users page for mobile' },
  { version: '1.0.144', date: '06-05-2026', type: 'ui', description: 'scale down Brugerstyring heading on mobile' },
  { version: '1.0.143', date: '06-05-2026', type: 'ui', description: 'improve mobile layout for admin users table and profile buttons' },
  { version: '1.0.142', date: '06-05-2026', type: 'fix', description: 'broken template literal in admin page notification toggle className' },
  { version: '1.0.141', date: '06-05-2026', type: 'ui', description: 'compact admin page buttons for mobile' },
  { version: '1.0.140', date: '06-05-2026', type: 'chore', description: 'migration to sync contactEmail with login email for all users' },
  { version: '1.0.139', date: '06-05-2026', type: 'feat', description: 'log reminder channels (app/push/mail) in audit log' },
  { version: '1.0.138', date: '06-05-2026', type: 'ui', description: 'make copy calendar URL a visible button with text label' },
  { version: '1.0.137', date: '06-05-2026', type: 'feat', description: 'tip of the day banner with calendar, profile, chat and notification tips' },
  { version: '1.0.136', date: '06-05-2026', type: 'feat', description: 'auto-update release notes from git log via pre-commit hook' },
  { version: '1.0.135', date: '06-05-2026', type: 'feat', description: 'add 2-hour VALARM reminder to all iCal events' },
  { version: '1.0.134', date: '06-05-2026', type: 'feat', description: 'permanent per-user calendar token for iCal feed (never expires)' },
  { version: '1.0.133', date: '06-05-2026', type: 'feat', description: 'admin release notes page with history from v1.0.120' },
  { version: '1.0.132', date: '06-05-2026', type: 'feat', description: 'personalized iCal feed — exclude not_attending events per user' },
  { version: '1.0.131', date: '06-05-2026', type: 'feat', description: 'default emailEventReminder to true — opt-out instead of opt-in' },
  { version: '1.0.130', date: '06-05-2026', type: 'fix', description: 'move early return after all hooks in FeedPage (Rules of Hooks)' },
  { version: '1.0.129', date: '06-05-2026', type: 'ui', description: 'fix send-notification button using project CSS classes' },
  { version: '1.0.128', date: '06-05-2026', type: 'ui', description: 'make send-notification section more prominent on edit event page' },
  { version: '1.0.127', date: '06-05-2026', type: 'fix', description: 'skip caching non-GET requests in service worker' },
  { version: '1.0.126', date: '06-05-2026', type: 'fix', description: 'add coComment and commentLike fields to prefs validation schema' },
  { version: '1.0.125', date: '06-05-2026', type: 'feat', description: 'configurable prefs for co-comment and comment-like notifications' },
  { version: '1.0.124', date: '06-05-2026', type: 'feat', description: 'notify comment author when their comment is liked' },
  { version: '1.0.123', date: '06-05-2026', type: 'feat', description: 'manual send-notification button on event edit page' },
  { version: '1.0.122', date: '06-05-2026', type: 'feat', description: 'notify co-commenters on shared post' },
  { version: '1.0.121', date: '02-05-2026', type: 'chore', description: 'Add clan meeting event type and feed filtering' },
  { version: '1.0.120', date: '20-04-2026', type: 'feat', description: 'slet besked-tråd (direkte og gruppe)' },
];

const typeBadge: Record<Release['type'], { label: string; style: React.CSSProperties }> = {
  feat:  { label: 'Ny feature', style: { background: '#d1fae5', color: '#065f46', border: '1px solid #6ee7b7' } },
  fix:   { label: 'Rettelse',   style: { background: '#fee2e2', color: '#991b1b', border: '1px solid #fca5a5' } },
  ui:    { label: 'Design',     style: { background: '#e0e7ff', color: '#3730a3', border: '1px solid #a5b4fc' } },
  chore: { label: 'Teknisk',    style: { background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db' } },
};

export default function AdminReleaseNotesPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && !user.isAdmin) {
      navigate('/');
    }
  }, [user, navigate]);

  if (!user?.isAdmin) return null;

  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-h1 font-heading font-bold">Release Notes</h1>
        <Link to="/admin/users" className="btn" style={{ fontSize: '0.9em', padding: '0.6em 1.2em' }}>
          ← Admin
        </Link>
      </div>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr style={{ borderBottom: '2px solid #e5e7eb' }}>
              <th className="text-left px-4 py-3 font-semibold text-gray-600" style={{ width: '110px' }}>Version</th>
              <th className="text-left px-4 py-3 font-semibold text-gray-600" style={{ width: '110px' }}>Dato</th>
              <th className="text-left px-4 py-3 font-semibold text-gray-600" style={{ width: '100px' }}>Type</th>
              <th className="text-left px-4 py-3 font-semibold text-gray-600">Ændring</th>
            </tr>
          </thead>
          <tbody>
            {releases.map((r, i) => {
              const badge = typeBadge[r.type];
              return (
                <tr key={r.version} style={{ borderBottom: i < releases.length - 1 ? '1px solid #f3f4f6' : 'none' }}>
                  <td className="px-4 py-3 font-mono text-gray-700 font-medium">{r.version}</td>
                  <td className="px-4 py-3 text-gray-500">{r.date}</td>
                  <td className="px-4 py-3">
                    <span style={{ ...badge.style, borderRadius: '4px', padding: '2px 8px', fontSize: '0.75rem', fontWeight: 600 }}>
                      {badge.label}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-gray-800">{r.description}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
